import AvatarProfile from "../../../../src/pages/design/getting-started/avatarProfile.js";
import * as React from 'react';
export default {
  AvatarProfile,
  React
};